import { isSodimacStandalone } from '@digital-retail/store-manager';
import apiConfig from '../../config/api/apiConfig';
import { httpService } from '../httpService';
import { getPageName } from '../urlHelper';
import { allowedAttributes, allowedPages, allowedPagesWithAttributes } from './helpers/constants';
import { getCrossHeaders } from './helpers/request';
import { isInterlinkingLogsEnabled } from './helpers/toggles';

export const getInterlinkingContent = async ({ appCtx, query, req, config }) => {
  const { store } = appCtx;
  const pageName = getPageName(appCtx.url);
  if (!allowedPages.includes(pageName)) {
    return {};
  }
  const pageId = query?.id;
  const pageType = pageName.toLowerCase();
  const attribute = {
    name: '',
    value: '',
  };
  if (allowedPagesWithAttributes.includes(pageName)) {
    const foundAttributeName = allowedAttributes.find((attributeName) => query?.[`f.${attributeName}`]);
    attribute.name = foundAttributeName || '';
    attribute.value = query?.[`f.${foundAttributeName}`] || false;
  }
  const isFallbackEnabled = isSodimacStandalone(store);
  const apiUrl = apiConfig.getInterlinkingUrl({
    base: config.CLUSTER_INTERLINKING_API_HOST,
    pageType,
    rest: {
      id: pageId,
      attributeName: attribute.name,
      attributeValue: attribute.value,
      store: store || '',
      fallback: isFallbackEnabled,
    },
  });
  const apiResponseFallback = {
    data: {},
    statusCode: 200,
    headers: {},
  };
  const apiResponse = await httpService(appCtx).get(
    apiUrl,
    {
      includeTracing: true,
      reqId: req?.id,
      headers: {
        'Content-Type': 'application/json',
        ...appCtx.tracingHeaders,
        ...getCrossHeaders(appCtx.tenant),
      },
    },
    'json',
    {
      ...(!isInterlinkingLogsEnabled(appCtx.siteConfig?.toggles) && apiResponseFallback),
    }
  );
  const interlinkingContent = apiResponse?.data || {};

  const isValidContent = !!apiResponse?.data?.groups?.length;
  if (!isValidContent) {
    return {};
  }
  return interlinkingContent;
};
